
import Icon from '../../../components/AppIcon';

const SocialLoginButtons = ({ onSocialLogin, isLoading }) => {
  const socialProviders = [
    {
      name: 'Google',
      icon: 'Chrome',
      color: '#4285F4'
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: '#1877F2'
    },
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: '#0A66C2'
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-3">
      {socialProviders?.map((provider) => (
        <button
          key={provider?.name}
          type="button"
          onClick={() => onSocialLogin(provider?.name?.toLowerCase())}
          disabled={isLoading}
          className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-border bg-card hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label={`Sign in with ${provider?.name}`}
        >
          <Icon name={provider?.icon} size={20} color={provider?.color} />
          <span className="hidden sm:inline text-sm font-medium text-foreground">{provider?.name}</span>
        </button>
      ))}
    </div>
  );
};

export default SocialLoginButtons;